export default __webpack_public_path__ + "static/media/10-3D (4-3).8808384e.jpg";